import React from "react";
import { Button } from "../../../components/Button";
import exclamation from "../../../assets/images/SVG/exclamation_danger.svg";
import successIcon from "../../../assets/images/SVG/check-done-success.svg";
import { MENSAJES } from '../../../utils/Constants'

const Modal = ({
  titulo = "Advertencia",
  cuerpo,
  onCancel,
  modalType = "warning",
  recibo,
  autorizacion,
}) => {
  if (modalType === "success") {
    return (
      <div id="centeredModal" className="modal-wrapper modal-is-open">
        <div className="overlay"></div>
        <div className="modal modal-centered">
          <div className="modal-content rounded-lg bg-white p-10 flex flex-col items-center justify-center w-2/3">
            <img src={successIcon} alt="Exclamation icon" className="w-1/3" />
            <div className="text-primary text-opacity-700 text-3xl text-center mt-5 font-bold leading-none">
              {titulo}
            </div>
            <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
              {cuerpo}
            </p>
            {/* <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
              {MENSAJES.NOTIFICACION_PAGO.MENSAJE_RECIBO_HUMANO} {recibo}
            </p> */}
            <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
              {MENSAJES.NOTIFICACION_PAGO.MENSAJE_RECIBO_TRANSACCION} {autorizacion}
            </p>
            <div className="w-2/3 mx-auto mt-5">
              <Button
                className="btn btn-outline btn-sm btn-primary w-full"
                onClick={onCancel}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="centeredModal" className="modal-wrapper modal-is-open">
      <div className="overlay"></div>
      <div className="modal modal-centered">
        <div className="modal-content rounded-lg bg-white p-10 flex flex-col items-center justify-center w-2/3">
          <img src={exclamation} alt="Exclamation icon" className="w-1/3" />
          <div className="text-primary text-opacity-700 text-3xl text-center mt-5 font-bold leading-none">
            {titulo}
          </div>
          <p className="text-primary opacity-75 text-2xl text-center leading-none mt-5">
            {cuerpo}
          </p>
          <div className="w-2/3 mx-auto mt-5">
            <Button
              className="btn btn-outline btn-sm btn-primary w-full"
              onClick={onCancel}
            >
              Ok
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
